import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo } from '../components/FeaturedSolutions';

const A = '/assets/casino/solutions/';

const solutions = [
  { name: 'InfoGenesis', path: 'info-genesis', screenshot: A + 'kiosk-retail.png' },
  { name: 'Eatec',       path: 'eatec',        screenshot: A + 'tablet-eatec.png' },
];

function GasStation() {
  const navigate = useNavigate();
  return (
    <div className="page splash gasStationPage">
      <div className="background" />
      <div className="page-header">Gas Station / Market</div>
      <div className="text-blocks">
        <div className="std-text">
          Simplify pump management with POS integration to seamlessly display a pump management console for managing pump status and car wash sales at the POS terminal. And use Agilysys POS solutions to manage all convenience store sales with integration to the rest of your property POS management.
        </div>
      </div>
      <FeaturedSolutions>
        {solutions.map((sol) => (
          <div key={sol.path} className="featured-item" onClick={() => navigate(`/solutions/${sol.path}`)}>
            <div className="item-head"><AgilysysLogo />{sol.name}</div>
            <img src={sol.screenshot} alt={sol.name} />
          </div>
        ))}
      </FeaturedSolutions>
    </div>
  );
}

export default GasStation;
